import { ThunkAction } from "redux-thunk";
import { Action } from "redux";

import { RootState } from "app/redux/reducer";
import { ActivityCommunityService } from "./service";
import { showMessage, toggleConfirmDialog, toggleLoader } from "app/redux/system/actions";
import { initialPageData } from "app/redux/page/actions";
import { MessageType } from "app/redux/system/types";
import { IActivityCommunity } from "./types";
import { HttpStatusCode, IList, IListFilter } from "app/shared";
import { mapActivityCommunityFromEntity, mapActivityCommunityFromModel } from "./mapping";

type ThunkResult<R> = ThunkAction<R, RootState, {}, Action>;

export function getActivityCommunity(id: string, language?: string, notFill?: boolean): ThunkResult<Promise<any>> {
    return async (dispatch, getState) => {
        const service = new ActivityCommunityService();
        dispatch(toggleLoader());
        const response = await service.getActivityCommunity(id, language || getState().system.defaultLanguage);
        dispatch(toggleLoader());

        if (response.status === HttpStatusCode.OK) {
            const mapped = mapActivityCommunityFromEntity(response.data.attributes["activityCommunity"] || {});

            if (!notFill) {
                dispatch(initialPageData<IActivityCommunity>(mapped));
            }

            return mapped;
        }
        dispatch(showMessage("Bir hata oluştu. Servis sağlayıcınızla iletişime geçin ya da daha sonra tekrar deneyiniz!", "Bir Hata Oluştu!", MessageType.ERROR))
        return false;
    };
}

export function getActivityCommunityByLanguage(pageData: IActivityCommunity, language: string, isOverride?: boolean): ThunkResult<Promise<any>> {
    return async (dispatch, getState) => {
        const service = new ActivityCommunityService();
        dispatch(toggleLoader());
        const response = await service.getActivityCommunity(pageData.id as string, isOverride ? getState().system.defaultLanguage : language);
        if (response.status === HttpStatusCode.OK) {
            const mapped = mapActivityCommunityFromEntity(response.data.attributes["activityCommunity"] || {});
            const data = { ...mapped, language: language, id: isOverride ? pageData.id : mapped.id };
            dispatch(initialPageData<IActivityCommunity>(data));
            if (isOverride) {
                dispatch(updateActivityCommunity(data));
            }
            dispatch(toggleLoader());
            return true;
        }
        else {
            dispatch(toggleConfirmDialog(true, {
                title: "Uyarı!",
                text: `Geçerli dil'e (${language}) ait bir kayıt bulunamadı. Varsayılan dil üzerinden seçtiğiniz dile göre kayıt oluşturulsun mu?`,
                button: {
                    approveText: "Varsayılan Dil'den Oluştur"
                },
                callback: () => {
                    dispatch(createActivityCommunity({ ...pageData, id: "", title: `${pageData.title} (${language.toUpperCase()})`, language })).then(res => {
                        if (res) {
                            dispatch(getActivityCommunity(res.id as string, language));
                        }
                    });
                    return true;
                }
            }))
        }
        dispatch(toggleLoader());
        return false;
    };
}


export function getActivityCommunities(options: IListFilter): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new ActivityCommunityService();
        dispatch(toggleLoader());
        const response = await service.getActivityCommunities(options);
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            const mapped = (response?.data?.attributes?.list || []).map((item) =>
                mapActivityCommunityFromEntity(item)
            );
            dispatch(initialPageData<IList<IActivityCommunity[]>>({
                list: mapped,
                pageSize: response.data.attributes.pageSize,
                totalCount: response.data.attributes.total,
                pageCount: Math.ceil(response.data.attributes.total / response.data.attributes.pageSize)
            }));
            return true;
        }
        return false;
    };
}

export function getActivityCommunitiesForLocal(language: string): ThunkResult<Promise<IActivityCommunity[]>> {
    return async () => {
        const service = new ActivityCommunityService();
        const response = await service.getActivityCommunities({ page: 1, pageSize: 100, descending: false, language });
        if (response.status === HttpStatusCode.OK) {
            const mapped = (response?.data?.attributes?.list || []).map((item) =>
                mapActivityCommunityFromEntity(item)
            );
            return mapped;
        }
        return [];
    };
}

export function createActivityCommunity(request: IActivityCommunity): ThunkResult<Promise<IActivityCommunity | null>> {
    return async (dispatch) => {
        const service = new ActivityCommunityService();
        dispatch(toggleLoader());
        const response = await service.createActivityCommunity(mapActivityCommunityFromModel(request));
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return mapActivityCommunityFromEntity(response.data.attributes["activityCommunity"] || {});
        }
        return null;
    };
}

export function updateActivityCommunity(request: IActivityCommunity): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new ActivityCommunityService();
        dispatch(toggleLoader());
        const response = await service.updateActivityCommunity(mapActivityCommunityFromModel(request));
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return true;
        }
        return false;
    };
}

export function deleteActivityCommunity(id: string): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new ActivityCommunityService();
        dispatch(toggleLoader());
        const response = await service.deleteActivityCommunity(id);
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return true;
        }
        dispatch(showMessage("Bir hata oluştu. Servis sağlayıcınızla iletişime geçin ya da daha sonra tekrar deneyiniz!", "Bir Hata Oluştu!", MessageType.ERROR))
        return false;
    };
}